import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, Phone, Mail } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

export default function RequestRejected() {
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 bg-destructive/10 rounded-full flex items-center justify-center">
            <AlertCircle className="h-6 w-6 text-destructive" />
          </div>
          <CardTitle className="text-xl font-semibold">Solicitação Recusada</CardTitle>
          <CardDescription className="text-center">
            Sua solicitação de acesso à organização foi recusada pelo administrador.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-sm text-muted-foreground space-y-3">
            <p>Para mais informações, entre em contato com o RH da sua organização:</p>
            
            <div className="bg-muted/50 rounded-lg p-3 space-y-2">
              <div className="flex items-center justify-center gap-2">
                <Mail className="h-4 w-4" />
                <span className="font-medium">contato@lyrarh.com.br</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <Phone className="h-4 w-4" />
                <span className="font-medium">(11) 97832-0011</span>
              </div>
            </div>
            
            <p className="text-xs">
              Você pode tentar novamente criando uma nova conta ou entre em contato para esclarecimentos.
            </p>
          </div>
          
          <Button onClick={handleSignOut} className="w-full" variant="outline">
            Voltar ao Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}